define(["mw-remote/serviceRegistryLookup","/local/buildagent/work/7bfdef0d49469377/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js",""], function(loader, runner) {
   return runner(loader, "", __webpack_require__.dj.c(), true);
});